import React, { useMemo } from 'react';
import { TCreateCustomerSelectedItem } from '../../createCustomerState/createCustomerContext';
import { IGetLanguages } from 'types';
import { ISelectOption } from 'components/Select/types';
import { useFetchData } from 'hooks/useFetchData';
import { Rule } from 'antd/lib/form';
import { useTranslation } from 'react-i18next';
import { getLanguages } from 'backend/additionalInformation';
import { FormSelectNew } from 'components/Select/FormSelectNew';

interface IProps {
	IDSelectedCustomerDefaultLanguage: TCreateCustomerSelectedItem;
	IDsSelectedCustomerLanguages: string[];
	setCustomerLanguages: (value: string[]) => void;
}

export const LanguagesMultipleSelect: React.FC<IProps> = React.memo(
	({ IDSelectedCustomerDefaultLanguage, IDsSelectedCustomerLanguages, setCustomerLanguages }) => {
		const { response, loading, refetch, responseError } = useFetchData<IGetLanguages, null>(getLanguages);
		const { t } = useTranslation('error');
		const { t: tForm } = useTranslation('form');

		const validationRules = useMemo<Rule[]>(
			() => [
				{ required: true, message: t('selectOneLanguage') },
				() => ({
					validator() {
						if (
							IDSelectedCustomerDefaultLanguage &&
							IDsSelectedCustomerLanguages.includes(IDSelectedCustomerDefaultLanguage)
						) {
							return Promise.resolve();
						}
						return Promise.reject(new Error(t('mustContainDefaultLanguage')));
					},
				}),
			],
			[IDSelectedCustomerDefaultLanguage, IDsSelectedCustomerLanguages, t],
		);

		const options = useMemo<ISelectOption[]>(
			() =>
				response?.data.languages.map((language) => ({
					id: language.id,
					name: tForm(language.name),
				})) || [],
			[tForm, response],
		);

		return (
			<FormSelectNew
				testId="LanguagesMultipleSelect"
				name="IDsSelectedCustomerLanguages"
				label="translationsLabel"
				options={options}
				fetchError={responseError}
				loading={loading}
				mode="multiple"
				withSearch={false}
				validationRules={validationRules}
				onRefetch={refetch}
				onChange={setCustomerLanguages}
			/>
		);
	},
);
